const styles = (theme) => ({
    formControl: {
        margin: theme.spacing(1),
    }
});

export default styles;